import {motion} from 'framer-motion';
import {reviews} from '../../../../../../model/common/Review';
import AnimatedLink from '../../../../../ui/motion/AnimatedLink';

const reviewCount = reviews.length;
const averageRating = reviews.reduce((sum, r) => sum + r.rating, 0) / reviewCount;
const displayAverage = averageRating.toFixed(2).replace('.', ',');

interface SocialProofBarProps {
    buttonText?: string;
    buttonTarget?: string;
}

export default function SocialProofBar({buttonText, buttonTarget}: SocialProofBarProps) {
    return (
        <motion.div
            initial={{opacity: 0, y: 20}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: 0.5, delay: 0.2}}
            className="my-6 text-center"
        >
            <div className="d-flex flex-wrap justify-content-center align-items-center gap-2">
                <div className="d-flex align-items-center gap-1">
                    {[1, 2, 3, 4, 5].map(i => (
                        <i key={i} className="bi bi-star-fill text-warning fs-9"></i>
                    ))}
                </div>
                <span className="text-white fw-semibold fs-10">{displayAverage}</span>
                <span className="text-white-50 fs-11">({reviewCount} opinii)</span>
            </div>
            <AnimatedLink
                hashLink={true}
                to={buttonTarget ?? '#co-musi-sie-zmienic'}
                className='btn btn-outline-success btn-lg fw-bold px-5 py-3 mt-5'
            >
                {buttonText ?? 'Zobacz, jak to działa'}
            </AnimatedLink>
        </motion.div>
    );
}
